export default {
  error_msg: (state) => state.error_msg,
  errors: (state) => state.errors,
  success: (state) => state.success,
  consultants: (state) => state.consultants,
  consultant: (state) => state.consultant,
  next_consultants_url: (state) => state.next_consultants_url,
  requested_consultant(state) {
    return state.consultants.find(
      (consultant) => consultant.id === +state.requested_consultant_id
    );
  },
};
